<template>
    <common-page card-content>
        <mini-table :fields="durationMode?durationTableConfig:paramsTableConfig"
                    :items="records"
                    :entityName="durationMode?'al-duration':'al-params'"
                    :loading="loading"
                    read-only
                    filterable filter-switch-able
                    enable-chart-generator
                    auto-page-view>
            <template #leftHeader>
                <b-form-datepicker class="w-300px" v-model="fromDate"></b-form-datepicker>
                <div class="d-flex align-content-center">
                    <i class="fa-solid fa-minus m-auto"></i>
                </div>
                <b-form-datepicker class="w-300px" v-model="toDate" today-button></b-form-datepicker>
                <mini-button @btnClick="getRemoteData" :disable="loading" class="ml-1">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    Search
                </mini-button>
            </template>
            <template #rightHeader>
                <b-button :variant="durationMode?'info':'outline-info'" @click="switchMode">
                    <i class="fa-regular fa-clock"></i>
                </b-button>
            </template>
        </mini-table>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import moment from "moment";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "ALDuration",
    components: {MiniButton, MiniTable, CommonPage},
    data() {
        return {
            durationTableConfig: [
                {key: 'uuid', label: 'UUID', form: {type: 'input'}},
                {key: 'tag', label: 'Tag', form: {type: 'input'}},
                {key: 'duration', label: 'Duration', form: {type: 'inputNumber'}},
                {key: 'createdBy', label: 'User', form: {type: 'input'}},
                {key: 'createdTime', label: 'Date', form: {type: 'datetimepicker'}},
            ],
            paramsTableConfig: [
                {key: 'uuid', label: 'UUID', form: {type: 'input'}},
                {key: 'tag', label: 'Tag', form: {type: 'input'}},
                {key: 'queryParam', label: 'Param', form: {type: 'input'}},
                {key: 'paramValue', label: 'Value', form: {type: 'input'}},
                {key: 'createdBy', label: 'User', form: {type: 'input'}},
                {key: 'createdTime', label: 'Date', form: {type: 'datetimepicker'}},
            ],
            records: [],
            fromDate: '',
            toDate: new Date(),
            loading: false,

            durationMode: true,
        }
    },
    computed: {},
    created() {
        this.fromDate = this.getDaysLater(-3);
        this.toDate = this.getDaysLater(1);
    },
    mounted() {
        this.getRemoteData();
    },
    methods: {
        getRemoteData() {
            let startDate = moment(this.fromDate).format(this.$t("em.datetime.format.viewMode"));
            let endDate = moment(this.toDate).format(this.$t("em.datetime.format.viewMode"));
            if (endDate < startDate) {
                this.$message.warning("开始时间不能大于结束时间");
                return;
            }
            this.loading = true;
            this.$store.dispatch('api/post', {
                url: `${process.env.VUE_APP_EM_ADMIN_URL}/analytics/log/${this.durationMode ? 'duration' : 'params'}`,
                data: {
                    from: startDate,
                    to: endDate
                }
            }).then(response => {
                this.records = response.data;
            }).finally(() => this.loading = false);
        },
        getDaysLater(day_num) {
            let date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * day_num);
            return date
        },
        switchMode() {
            this.durationMode = !this.durationMode;
            this.getRemoteData();
        },
    }
}
</script>

<style scoped>
.w-300px {
    width: 250px;
}
</style>
